import {
  BranchItem,
  CategoriesServicesObjectData,
  QueueItem,
  SectionOrServiceForTable,
} from '../../../types/Admin/CategoriesTopicsTypes';

type BindingSource = {
  id?: number;
  branches?: BranchItem[];
  queues?: QueueItem[];
};

const mergeById = <T extends { id: number }>(
  ...lists: Array<T[] | undefined>
): T[] => {
  const map = new Map<number, T>();
  for (const list of lists) {
    for (const item of list ?? []) {
      map.set(item.id, item);
    }
  }
  return Array.from(map.values());
};

const collectMatchingFromTree = (
  rows: SectionOrServiceForTable[] | undefined,
  entityId: number,
  expectedRadioType: 'section' | 'service',
): BindingSource[] => {
  const result: BindingSource[] = [];

  const walk = (nodes: SectionOrServiceForTable[] | undefined) => {
    for (const node of nodes ?? []) {
      if (node.id === entityId && node.radioType === expectedRadioType) {
        result.push(node);
      }
      walk(node.subRows);
    }
  };

  walk(rows);
  return result;
};

export const resolveBindingsForEdit = (
  modalData: BindingSource | null | undefined,
  tableData: CategoriesServicesObjectData | undefined,
  kind: 'section' | 'service',
) => {
  const fromModalBranches = modalData?.branches ?? [];
  const fromModalQueues = modalData?.queues ?? [];

  if (!modalData?.id || !tableData) {
    return {
      branchIds: fromModalBranches.map((branch) => branch.id),
      queueIds: fromModalQueues.map((queue) => queue.id),
    };
  }

  const expectedRadioType = kind === 'service' ? 'service' : 'section';
  const matchingRows: BindingSource[] =
    kind === 'service'
      ? (tableData.services ?? []).filter((row) => row.id === modalData.id)
      : (tableData.sections ?? []).filter((row) => row.id === modalData.id);

  const matchingFromTree = collectMatchingFromTree(
    tableData.all,
    modalData.id,
    expectedRadioType,
  );

  const branches = mergeById<BranchItem>(
    fromModalBranches,
    ...matchingRows.map((row) => row.branches),
    ...matchingFromTree.map((row) => row.branches),
  );
  const queues = mergeById<QueueItem>(
    fromModalQueues,
    ...matchingRows.map((row) => row.queues),
    ...matchingFromTree.map((row) => row.queues),
  );

  return {
    branchIds: branches.map((branch) => branch.id),
    queueIds: queues.map((queue) => queue.id),
  };
};
